import React, { useContext, useRef } from "react";
import type { Page } from "@r6digital/rapidstor-types/types/Questionnaire";
import QuestionnaireContext from "./QuestionnaireContext";
import { Button } from "react-bootstrap";
import { ReactComponent as IconArrowRight } from "../../assets/icon-arrow-right.svg";
import { changePage, selectResponses, setResponse } from "../../store/questionnaireSlice";
import store from "../../store";
import { useSelector } from "react-redux";
import { useLoaderData, useNavigate } from "react-router-dom";
import Question from "./Question";
import Location from "../../features/rapidstor/entities/Location";

interface Props {
  page: Page;
}

function Page({ page }: Props) {
  const { questionnaire } = useContext(QuestionnaireContext);
  const location = useLoaderData() as Location;
  const responses = useSelector(selectResponses);
  const navigate = useNavigate();
  const form = useRef<HTMLFormElement>(null);

  if (!questionnaire) {
    return <div>Questionnaire loading...</div>;
  }

  const questions = page.questions.map((id) => ({ id, ...questionnaire.questions[id] }));

  const questionElements = questions.map((question) => (
    <Question key={question.id} id={question.id} question={question} />
  ));

  const showButton = page.nextPage || page.last;

  const unansweredQuestions = questions.filter((question) => {
    if (question.required === false) {
      return false;
    }
    return !responses || responses[question.id] === undefined;
  });

  const nextPage = () => {
    if (!form.current?.reportValidity()) {
      return;
    }
    if (page.nextPage) {
      store.dispatch(changePage(questionnaire.pages[page.nextPage]));
    } else if (page.last) {
      navigate(`/locations/${location.slug}/units`);
    }
  };

  const handleSubmit = () => {
    nextPage();
  };

  const skipToUnitListing = (event: React.MouseEvent) => {
    event.preventDefault();
    store.dispatch(setResponse({ id: "storageType", response: "All Units" }));
    navigate(`/locations/${location.slug}/units`);
  };

  // const skipToRapidstor = (event: React.MouseEvent) => {
  //   event.preventDefault();
  //   store.dispatch(setResponse({ id: "storageType", response: "All Units" }));
  //   navigate("/booking");
  // };

  return (
    <>
      <form ref={form} onSubmit={handleSubmit}>
        <div>{questionElements}</div>
        {showButton && (
          <div className={"text-end mt-4"}>
            <Button
              className={"btn-lg"}
              disabled={unansweredQuestions.length > 0}
              onClick={nextPage}
            >
              Continue <IconArrowRight className={"ms-2"} />
            </Button>
          </div>
        )}
        {page.id === "root" && (
          <div className={"mt-2 text-center"}>
            <a className={"link transparent"} href={"#"} onClick={skipToUnitListing}>
              Just show me size & pricing
            </a>
          </div>
        )}
      </form>
    </>
  );
}

export default Page;
